import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid2";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";

export default function DialogPriorityText({
  openDialogPriority,
  setOpenDialogPriority,
}) {
  const handleClose = () => {
    setOpenDialogPriority(false);
  };

  return (
    <Dialog
      open={openDialogPriority}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description">
      <DialogTitle>
        <IconButton
          color="primary"
          sx={{ right: 0, left: "95%" }}
          onClick={() => setOpenDialogPriority(false)}
          aria-label="icons-close">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography>
          Caso seja necessário, basta marcar a opção "Solicitar prioridade".
        </Typography>
        <Typography sx={{ fontWeight: "bold" }}>
          Atente-se de que será acrescido R$10,00 ao valor solicitado.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Grid container>
          <Grid item size={12} align="right">
            <Button onClick={handleClose}>Fechar</Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
}
